import React, { ReactChild, ReactNode } from "react";
import { cls } from "cls";

interface Props {
  header?: ReactNode;
  children: ReactChild;
  backgroundColor: string;
  hasUpcomingDeal?: boolean;
  isUpcomingDeal?: boolean;
}

const ActiveFlashDealContainer = ({
  header,
  children,
  hasUpcomingDeal,
  isUpcomingDeal,
}: Props) => {
  return (
    <div
      className={cls(
        "bg-white",
        "rounded",
        "flex",
        "flex-col",
        hasUpcomingDeal ? "md:w-1/2" : "",
      )}
    >
      <div
        className={cls("px-4", "py-2")}
        style={{ borderBottom: "1px solid #d9d9d9" }}
      >
        {header}
      </div>
      <div className={cls("flex", "h-full", !isUpcomingDeal ? "p-4" : "")}>
        {children}
      </div>
    </div>
  );
};

export default ActiveFlashDealContainer;
